<template>
  <div class="alert-monitor-test-page">
    <div class="page-card">
      <h1 class="page-title">告警接口测试页</h1>
      <p class="page-desc">输入访问 code 后，才可以手动发送一条带测试标记的告警请求。</p>

      <div class="section-block">
        <div class="field-label">访问 Code</div>
        <el-input
          v-model.trim="accessCode"
          show-password
          placeholder="请输入访问 code"
          @keyup.enter.native="verifyAccessCode"
        />
        <el-button
          class="action-btn"
          type="primary"
          :loading="verifying"
          @click="verifyAccessCode"
        >
          验证进入
        </el-button>
      </div>

      <div v-if="accessGranted" class="section-block unlocked-panel">
        <div class="field-label">测试说明</div>
        <div class="test-message">
          本次发送内容会明确带上 <code>[alert-monitor-test]</code> 标记，仅用于接口联调验证。
        </div>
        <el-button
          class="action-btn"
          type="danger"
          :loading="sending"
          @click="sendTestAlert"
        >
          发送测试告警
        </el-button>
      </div>

      <div v-if="responseText" class="section-block">
        <div class="field-label">接口返回</div>
        <pre class="response-box">{{ responseText }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
import { triggerAlertMonitor } from '@/api/common';
import {
  buildAlertMonitorTestExtraData,
  isAlertMonitorAccessCodeValid,
} from '@/utils/alertMonitor';

export default {
  name: 'AlertMonitorTestPage',
  data() {
    return {
      accessCode: '',
      accessGranted: false,
      verifying: false,
      sending: false,
      responseText: '',
    };
  },
  methods: {
    async verifyAccessCode() {
      this.verifying = true;

      try {
        const isValid = await isAlertMonitorAccessCodeValid(this.accessCode);

        if (!isValid) {
          this.accessGranted = false;
          this.$message.error('访问 code 不正确');
          return;
        }

        this.accessGranted = true;
        this.$message.success('验证通过，可以发送测试告警');
      } catch (error) {
        this.$message.error(`code 校验失败：${error.message || '未知错误'}`);
      } finally {
        this.verifying = false;
      }
    },
    async sendTestAlert() {
      this.sending = true;

      try {
        const response = await triggerAlertMonitor(
          buildAlertMonitorTestExtraData({
            routePath: this.$route.fullPath,
          }),
        );

        this.responseText = JSON.stringify(response, null, 2);

        if (response && response.success) {
          this.$message.success(`测试告警发送成功：${response.respCode || '20000'}`);
        } else {
          this.$message.error(`测试告警发送失败：${response?.respMsg || '未知错误'}`);
        }
      } catch (error) {
        this.responseText = JSON.stringify({
          message: error.message,
          response: error.response && error.response.data,
        }, null, 2);
        this.$message.error(`测试告警请求失败：${error.message || '网络异常'}`);
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.alert-monitor-test-page {
  min-height: 100vh;
  padding: 40px 16px;
  background: #f5f7fb;
}

.page-card {
  max-width: 720px;
  margin: 0 auto;
  padding: 32px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 12px 36px rgba(24, 32, 88, 0.08);
  text-align: left;
}

.page-title {
  margin: 0 0 12px;
  font-size: 30px;
  line-height: 1.2;
  color: #182058;
}

.page-desc {
  margin: 0 0 24px;
  color: #5b6475;
  line-height: 1.6;
}

.section-block {
  margin-top: 24px;
}

.field-label {
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #182058;
}

.action-btn {
  margin-top: 16px;
}

.unlocked-panel {
  padding: 20px;
  border-radius: 12px;
  background: #fff7f7;
  border: 1px solid #ffd8d8;
}

.test-message {
  color: #6a3340;
  line-height: 1.6;
}

.response-box {
  margin: 0;
  padding: 16px;
  border-radius: 12px;
  background: #0f172a;
  color: #dbeafe;
  line-height: 1.6;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
